import React, { useContext } from "react";
import { REPORT_PAGES_ROUTES } from "../../../constants";
import { policyStateFiltered } from "../../../store/policiesSlice";
import { SafeAssessment } from "../../../ui";
import { LinkToReportTab } from "../../common";
import { ReportContext } from "../../context";
import { useReportDispatch, useRiskAssessmentClick } from "../../hooks";
import styles from "./riskAssessment.module.scss";
const RiskCountWrapper = ({ riskCategory, risk, children, }) => {
    const { reportId, diffId, selectedCheck } = useContext(ReportContext);
    const { linkTarget, handleRiskCountClick } = useRiskAssessmentClick({
        reportId,
        diffId,
        riskCategory,
        selectedCheck,
        violations: risk.violations,
    });
    return (React.createElement(LinkToReportTab, { id: `${riskCategory}-count`, to: linkTarget, className: styles["risk-count"], onClick: handleRiskCountClick }, children));
};
const RiskAssessmentContainer = ({ risk, disabledPoliciesCount, }) => {
    const dispatch = useReportDispatch();
    return (React.createElement(SafeAssessment.Panel, { disabledPoliciesCount: disabledPoliciesCount, disabledPoliciesCountWrapper: (children) => (React.createElement(LinkToReportTab, { id: `${disabledPoliciesCount.toLocaleString()} policies were disabled`, to: REPORT_PAGES_ROUTES.POLICIES_ROUTE, color: "link", onClick: () => dispatch(policyStateFiltered("disabled")) }, children)) }, React.createElement(SafeAssessment.Assessment, { risk: risk, risksCountWrapper: (risk, riskCategory, children) => (React.createElement(RiskCountWrapper, { riskCategory: riskCategory, risk: risk }, children)) })));
};
export default RiskAssessmentContainer;
//# sourceMappingURL=RiskAssessment.js.map